export default {
  okText: 'Ok',
  dismissText: 'Avbryt',
  extra: 'vÃ¤nligen vÃ¤lj',
};
